export default "__VITE_ASSET__YWyzEhkB__"